declare var BASE_URL:string;
declare var STATIC_BASE_URL:string;

import '../styles/becomepartners.scss';

import { h, Component } from 'preact';

export default class Becomeapartner extends Component<any, any> {

    constructor() {
        super();
    }

    public render (props, state): any {

        return <div id="becomepartners">
            <div class="mainWrp">
              <section class="body center">
                <h1>Partners</h1>
                <h3>
                  We are always open to the market, and keen to enhance a collaboration with those who share the same vision of harnessing AI to create a better world.​
                </h3>
            </section>
          </div>
          {/*<section class="full grey">
              <h2>What our Partners think</h2>
              <ul>
                <li>
                  <blockquote>
                    Get a Quote or statement from Brian (Forbes) to boost the message here​
                    <span>Partner x</span>
                  </blockquote>
                </li>
              </ul>
              <p class="center"><a href={ STATIC_BASE_URL + 'contacts' } class="butt huge">Become a Partner</a></p>
          </section>*/}
          <section class="full grey">
            <h2>Types of Partnerships</h2>
            <ul class="types">
              <li>
                <div class="icon"><div><i class="fa fa-funnel-dollar"></i></div></div>
                <div class="descr">
                  <h3>Channel Partners</h3>
                  <p>
                    Partner with us to provide your customers with the world’s fastest AI technology and personalised expertise.
                  </p>
                </div>
              </li><li>
              <div class="icon"><div><i class="fa fa-microchip"></i></div></div>
              <div class="descr">
                <h3>Technology Partners</h3>
                <p>
                  Create new offerings with your data or complement your current technology with our AI solutions to gain more control.
                </p>
              </div>
            </li><li>
              <div class="icon"><div><i class="fa fa-rocket"></i></div></div>
              <div class="descr">
                <h3>Startup Partners</h3>
                <p>
                  Augment your products and strategy in your high-growth startup by adding AI capabilities and turn customers into life-long ambassadors.
                </p>
              </div>
            </li>
            </ul>
            <p class="center"><a href={ BASE_URL + 'contacts' } class="butt huge">Become a Partner</a></p>
          </section>
          
        </div>
    }
}


// WEBPACK FOOTER //
// ./ts/Becomeapartner.tsx